












import AppText from '@berlin-front/common/components/elements/AppText';
import { defineComponent, computed, PropType } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';

/**
 * ## ラジオボタン。
 *
 * 選択肢が決まってる入力を行う。
 *
 */
export default defineComponent({
  name: 'AppRadio',
  components: {
    AppText,
  },

  model: {
    event: 'select',
    prop: 'value',
  },

  props: {
    /**
     * 選択中の値。v-modelで指定した値が連動される。
     */
    value: {
      type: [String, Number, Boolean] as PropType<string | number | boolean>,
      required: true,
    },

    /**
     * 選択肢
     */
    values: {
      type: Array as PropType<Readonly<(string | number | boolean)[]>>,
      required: true,
    },

    /**
     * 選択肢の描画関数。引数にvalueをとって、戻り値として選択肢の表示テキストを返します。
     */
    valueRender: {
      type: Function as PropType<(value: string | number | boolean) => string>,
      default: (value: string | number | boolean) => `${value.toString()}`,
    },
  },

  emits: [
    /**
     * ラジオグループ内の別選択肢が選択された時に呼び出される。
     */
    'select',
  ],

  setup(props, context) {
    const model = computed({
      get: () => props.value,
      set: (value) => context.emit('select', value),
    });
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);

    return {
      className: 'AppRadio',
      model,
      primaryColor,
    };
  },
});
